export const tagLocale = {
    removeLabel: 'Remove',
};
//# sourceMappingURL=Tag.locale.mjs.mjs.map